import {
  MODEL_TYPE
} from './model_types'
import enumConstants from '../enumConstants.json'

export const PERSON_PAYMENT_ENTITY_TYPE_TO_MODEL_TYPE = {
  [enumConstants.person_payment_entity_types.ACCOUNT]: MODEL_TYPE.ACCOUNT,
  [enumConstants.person_payment_entity_types.EMPLOYEE]: MODEL_TYPE.EMPLOYEE
}
